import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteProgramGroup, ProgramActionKeys, programsActionCreators } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* deleteProgramGroupSaga(action: DeleteProgramGroup) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<number>> = yield call(
    api.deleteProgramGroup,
    action.payload.programGroupId
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(programsActionCreators.removeProgramGroup(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteProgramGroup() {
  yield takeEvery(ProgramActionKeys.DELETE_PROGRAM_GROUP, deleteProgramGroupSaga);
}
